export default function Svg({ name, className }) {
    const url = `/svg/sprite.svg?v=1#${name}`
    return (
        <svg className={className}>
            <use xlinkHref={url} href={url}></use>
        </svg>
    )
}
